import layout from './MLStringPopupBox.html?raw';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import MLStringPopupBoxViewModelType from '@/ViewModels/Controls/MLStringPopupBoxViewModel';
import MultilineTextBoxType from '@/Controls/MultilineTextBox';
import LinkType from '@/Controls/Link';
import WindowType from '@/Controls/Window';

export default class MLStringPopupBox extends Control {

    private MultiLineTextBox = ComponentManager.getControl<typeof MultilineTextBoxType>('MultiLineTextBox');
    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private Window = ComponentManager.getControl<typeof WindowType>('Window');
    private jQueryControl: JQuery;
    private multilineTextBox: MultilineTextBoxType;
    private link: LinkType;
    private window: WindowType;

    public constructor(private viewModel: MLStringPopupBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);
       
        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'mlstringpopupbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    if (this.viewModel.isEachLanguageEqual() === true) {
                        states.push('each-language-equal');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.multilineTextBox != null) {
            this.multilineTextBox = new this.MultiLineTextBox(this.viewModel.multilineTextBox);
            let tuple = this.multilineTextBox.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.link != null) {
            this.link = new this.Link(this.viewModel.link);
            let tuple = this.link.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        this.defineSubscription(this.viewModel.window, window => {
            if (window == null) {
                return;
            }
            this.window = new this.Window(window);
            let tuple = this.window.getTuple();

            tuple.control.appendTo(this.jQueryControl);

            this.applyBindings(this.window.getControl(), {
                hotkey: {
                    shortcut: 'esc',
                    handler: () => {
                        this.viewModel.buttons()[1].onClick();
                    },
                    isGlobal: false
                }
            });


            let inited = false;
            let subscribed = false;
            this.defineComputed(() => {
                if (inited) return;

                let content = window.content();
                let isOpen = window.isOpen();

                if (content != null && content.length > 0 && isOpen === true) {
                    inited = true;
                    window.isBusy(true);
                    this.applyTemplateAsync(layout, content, 1, () => {
                        window.isBusy(false);
                        this.window.center();

                        // Delay centering subscription to ensure it is run after the resize
                        if (!subscribed) {
                            this.defineSubscription(this.viewModel.window_isEachLanguageEqual, () => {
                                this.window.center();
                            });
                            subscribed = true;
                        }
                    });
                }
            });
        });
    }
}

ComponentManager.setControl('MLStringPopupBox', MLStringPopupBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');